import { render } from "./AssignPermissions.vue?vue&type=template&id=e96ede3e&scoped=true"
import script from "./AssignPermissions.vue?vue&type=script&lang=js"
export * from "./AssignPermissions.vue?vue&type=script&lang=js"

import "./AssignPermissions.vue?vue&type=style&index=0&id=e96ede3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96ede3e"]])

export default __exports__